const labels: Record<string, string> = {
  delivery_appointment: 'Delivery time window', requested_delivery_date: 'Requested date',
  delivery_address: 'Delivery address', contact_name: 'Jobsite contact name',
  contact_phone: 'Jobsite contact phone', contact_email: 'Jobsite contact email',
  ship_to_number: 'Ship-To account', branch_number: 'Branch', po_number: 'PO number',
  delivery_service: 'Delivery service', job: 'Job', items: 'Order items',
  type_code: 'Time window', from_time: 'From', to_time: 'To', instructions: 'Delivery instructions',
};

/** Preserve field names and nested line numbers from DRF validation responses. */
export function orderErrorMessage(error: unknown, fallback: string): string {
  const err = error as { response?: { data?: unknown }; responseData?: unknown; message?: string };
  const data = err?.response?.data ?? err?.responseData;
  function flatten(value: unknown, path: string[] = []): string[] {
    if (typeof value === 'string') return [path.length ? `${path.join(' → ')}: ${value}` : value];
    if (Array.isArray(value)) return value.flatMap((item, i) => flatten(item, typeof item === 'string' ? path : [...path, `Line ${i + 1}`]));
    if (value && typeof value === 'object') return Object.entries(value).flatMap(([key, item]) =>
      flatten(item, key === 'non_field_errors' ? path : [...path, labels[key] || key.replaceAll('_', ' ')]));
    return [];
  }
  if (data && typeof data === 'object') {
    for (const key of ['api_error', 'error', 'detail']) {
      const value = (data as Record<string, unknown>)[key];
      if (value) return flatten(value).join(' ');
    }
  }
  return flatten(data).join(' ') || err?.message || fallback;
}
